import React from 'react';
import { AlertDialog } from '@popmenu/admin-ui';
import { Typography } from '@popmenu/common-ui';

interface ConfirmationModalProps {
  cancelButtonText?: string,
  proceedButtonText?: string,
  confirmationAction: () => void,
  disabled?: boolean,
  formattedMessage: React.ReactElement | string,
  onClose: () => void,
  open: boolean,
  severity?: 'info' | 'error' | 'warning' | 'success'
  title?: string | undefined,
}

const ConfirmationModal = ({
  cancelButtonText = 'Cancel',
  confirmationAction,
  disabled,
  formattedMessage,
  onClose,
  open,
  proceedButtonText = 'Save',
  severity,
  title,
}: ConfirmationModalProps) => (
  <AlertDialog
    descriptionId="confirmation_modal.locations.description"
    labelId="confirmation_modal.locations.label"
    open={open}
    onClose={onClose}
    onCancel={onClose}
    cancelButtonText={cancelButtonText}
    disabled={disabled}
    proceedButtonText={proceedButtonText}
    onProceed={confirmationAction}
    severity={severity}
  >
    {title && (
      <Typography style={{ fontWeight: 'bold' }}>
        {title}
      </Typography>
    )}

    <Typography>
      {formattedMessage}
    </Typography>
  </AlertDialog>
);

export default ConfirmationModal;
